import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { SignOut, Trophy, Broadcast } from "@phosphor-icons/react";

export const Navbar = ({ onSubmit }) => {
  const { user, login, logout } = useAuth();
  const location = useLocation();

  return (
    <header
      data-testid="app-navbar"
      className="sticky top-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-[#E1FF00] flex items-center justify-center rounded-sm group-hover:rotate-6 transition-transform">
            <Broadcast size={20} weight="fill" className="text-black" />
          </div>
          <div className="leading-none">
            <div className="font-head font-extrabold text-base tracking-tighter">HDN VSN</div>
            <div className="font-mono text-[10px] text-[#E1FF00] uppercase tracking-[0.25em]">The Feed Room</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 md:gap-3">
          <Link to="/leaderboard" data-testid="nav-leaderboard">
            <Button variant="ghost" className="text-[#A1A1AA] hover:text-white hover:bg-white/5 rounded-none gap-2">
              <Trophy size={18} weight={location.pathname === "/leaderboard" ? "fill" : "regular"} />
              <span className="hidden sm:inline">Leaderboard</span>
            </Button>
          </Link>

          {user && onSubmit && (
            <Button
              data-testid="open-submit-button"
              onClick={onSubmit}
              className="bg-[#0038FF] hover:bg-[#002EDD] text-white font-bold rounded-none px-4 md:px-5"
            >
              Submit Track
            </Button>
          )}

          {user ? (
            <div className="flex items-center gap-3 pl-1">
              <Avatar className="h-9 w-9 border border-white/15">
                <AvatarImage src={user.picture} alt={user.name} />
                <AvatarFallback className="bg-[#B14AED] text-white text-xs font-bold">
                  {user.name?.[0]?.toUpperCase()}
                </AvatarFallback>
              </Avatar>
              <Button
                data-testid="logout-button"
                variant="ghost"
                size="icon"
                onClick={logout}
                className="text-[#A1A1AA] hover:text-[#FF3B30] hover:bg-white/5 rounded-none"
              >
                <SignOut size={20} />
              </Button>
            </div>
          ) : (
            <Button
              data-testid="google-login-button"
              onClick={login}
              className="bg-[#E1FF00] hover:bg-[#CBE600] text-black font-bold rounded-none px-4 md:px-5"
            >
              Sign In
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
};
